/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconLetterW = createReactComponent("outline", "letter-w", "IconLetterW", [["path", { "d": "M4 4l4 16l4 -14l4 14l4 -16", "key": "svg-0" }]]);

export { IconLetterW as default };
//# sourceMappingURL=IconLetterW.mjs.map
